query getXeroItems {
	xeroItems {
		code
		name
	}
} 